import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getData = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].data`), (data) => data);
export const getChanges = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].draft`), (draft) => draft);
export const getHasChanges = createSelector((state) => getChanges(state), (draft) => !isEmpty(draft));
export const getWorkSpaceId = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].workSpaceId`), (workSpaceId) => workSpaceId);
export const getDraft = createSelector((state) => getData(state), (state) => getChanges(state), (state) => getWorkSpaceId(state), (data, draft, workSpaceId) => {
    if (isNil(workSpaceId) || !data)
        return undefined;
    return {
        ...data,
        ...(draft || {})
    };
});
export const getInProgress = (state) => isPending(state, `${actionTypes.SAVE_WORK_SPACE}_${getWorkSpaceId(state)}`) ||
    isPending(state, `${actionTypes.GET_WORK_SPACE}_${getWorkSpaceId(state)}`);
